import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function Impressum() {
  const navigate = useNavigate();

  React.useEffect(() => { document.title = 'Impressum & Kontakt | 366Transfer.com GmbH Airport'; }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="impressum-page">
      <nav className="bg-white border-b border-slate-100 sticky top-0 z-40">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center gap-4">
          <button onClick={() => navigate(-1)} className="p-2 hover:bg-slate-100 rounded-lg transition-colors" data-testid="impressum-back-btn">
            <ArrowLeft size={20} className="text-slate-600" />
          </button>
          <a href="/" className="flex items-baseline gap-0.5">
            <span className="text-2xl font-extrabold text-orange-500">366</span>
            <span className="text-base font-semibold text-slate-800">Transfer</span>
          </a>
        </div>
      </nav>

      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-slate-900 mb-8">Impressum</h1>

        <div className="prose prose-slate max-w-none space-y-6 text-sm leading-relaxed text-slate-700">
          <section>
            <h2 className="text-lg font-semibold text-slate-800 mb-3">Angaben gemäß gesetzlicher Vorgaben</h2>
            <p>
              <strong>366Transfer OU</strong><br />
              Tartu mnt 67/1-13b<br />
              Tallinn - 10115<br />
              Estland (EE)
            </p>
            <p className="mt-3">
              Weitere Standorte:<br />
              Fahrwangen, AG, Schweiz<br />
              Marsa Alam, Rotes Meer, Ägypten
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 mt-8 mb-3">Vertretungsberechtigter Geschäftsführer</h2>
            <p>Abdelaal Hassanin</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 mt-8 mb-3">Kontakt</h2>
            <p>
              E-Mail: info@366transfer.com<br />
              Website: www.366transfer.com
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 mt-8 mb-3">Geschäftstätigkeit</h2>
            <p>366Transfer.com GmbH ist eine Online-Vermittlungsplattform für Flughafentransfers und Überlandfahrten. Das Unternehmen agiert als Vermittler zwischen Kunden und Fahrern bzw. Transportunternehmen. 366Transfer erbringt selbst keine Transportdienstleistungen.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 mt-8 mb-3">Haftungshinweis</h2>
            <p>Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 mt-8 mb-3">Urheberrecht</h2>
            <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 mt-8 mb-3">Streitschlichtung</h2>
            <p>Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit. Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
